// extracted by mini-css-extract-plugin
export default {"detail":"index_detail__Ge86k","user":"index_user__ULHZj","description":"index_description__4tk+O","extra":"index_extra__lnM6r","mobile":"index_mobile__oBNZY"};